export class AppConsts {

  static mapperLanguages = ['en' ];
  static formArrayMapperProp = '__formArray__';
  static nestedFormGroupProp = '__formGroup__';
  static dtoMapperProp = '__';
  static mapperFgm = 'FormGroupModel';
  static defaultSelectNull = 'null';
  static systemName = 'Samplicity.Platform.UI';
}
